// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".maincontent[data-v-55b4d011]{display:block;height:356px;text-align:center}.maincontent h1[data-v-55b4d011]{font-size:42px}.maincontent h1[data-v-55b4d011],.maincontent p[data-v-55b4d011]{color:#454749;font-family:Niveau Grotesk}.maincontent p[data-v-55b4d011]{font-size:20px;margin-bottom:36px}@media only screen and (max-width:600px){.maincontent[data-v-55b4d011]{margin-top:450px}}", ""]);
// Exports
module.exports = exports;
